import { Reducer } from 'redux';
import { AppConfigurationActionTypes } from '../actions/appConfiguration.actions';
import { AppConfigurationItemModel, initialAppConfigurationState } from '../store.model';

export const appConfigurationReducer: Reducer<AppConfigurationItemModel[]> = (
  state = initialAppConfigurationState,
  action
) => {
  switch (action.type) {
    case AppConfigurationActionTypes.STORE_APP_CONFIGURATION:
      return action.payload;
    default:
      return state;
  }
};
